import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AttachmentInputComponent } from 'elbuild-ui-componentslib';
import { Conf, CrudService, SharedDataService, MessageService, Attach } from 'elbuild-ui-lib-core';

@Component({
	selector: 'app-conf-edit',
	templateUrl: './conf-edit.component.html',
	styleUrls: ['./conf-edit.component.scss']
})
export class ConfEditComponent implements OnInit, OnDestroy {

	@ViewChild('attachment')
	attachment: AttachmentInputComponent;


	loading: boolean = false;
	productid: number;
	conf: Conf = new Conf();
	attachid: string;
	attachpath: string;

	get title(): string {
		return this.conf?.id ? 'conf-edit' : 'conf-create';
	}


	constructor(
		private confService: CrudService<Conf>,
		private sharedDataService: SharedDataService,
		private messageService: MessageService,
		private translateService: TranslateService,
		private activeModal: NgbActiveModal
	) { }

	ngOnInit() { }

	ngOnDestroy(): void {
		this.sharedDataService.addCommonData('route', undefined);
	}

	load(confid: number): void {
		this.loading = true;
		this.confService.getEntity(Conf, 'conf', confid).subscribe((c: Conf) => {
			this.conf = c;
			this.loading = false;
			if (this.conf.confkey == 'additati.support.file' && this.conf.confval) {
				this.attachid = this.conf.confval.split(':')[0];
				this.attachpath = this.conf.confval.split(':')[1];

			}
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.confs'));
			this.conf = undefined;
			this.loading = false;
		});
	}

	dismiss(): void {
		this.activeModal.dismiss();
	}




	upload() {
		return this.attachment.upload().subscribe((data: Attach) => {
			console.log(data);
			this.conf.confval = data.id + ':' + data.filename;
			this.attachid = data.id + '';
			this.attachpath = data.fspath;
			this.save();
			this.messageService.sendSuccess(
				this.translateService.instant('labels.upload-success'),
				this.translateService.instant('labels.success')
			);

		}, ({ error }) => {
			this.messageService.sendError(
				error.msg ? error.msg : error,
				this.translateService.instant('labels.upload-error')
			);
		});
	}

	submit(): void {
		if (this.conf.confkey == 'additati.support.file') {
			this.upload();
		} else {
			this.save()
		}

	}

	save() {
		if (!this.conf.id) {
			this.confService.createEntity(Conf, 'conf', this.conf).subscribe((response: Conf) => {
				this.conf = response;
				this.messageService.sendSuccess(
					this.translateService.instant('labels.conf-save-success'),
					this.translateService.instant('labels.success')
				);
				this.activeModal.close(this.conf);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		} else {
			this.confService.saveEntity(Conf, 'conf', this.conf).subscribe((response: Conf) => {
				this.conf = response;
				this.messageService.sendSuccess(
					this.translateService.instant('labels.conf-save-success'),
					this.translateService.instant('labels.success')
				);
				this.activeModal.close(this.conf);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		}
	}

}
